/**
 * AUTO GENERATED FILE. DO NOT EDIT.
 *
 * This file was auto-generated using the `generateVersionTs` script
 * in `tools/scripts`.
 *
 * Sun Nov 05 2023 18:33:12 GMT+0100 (GMT+01:00)
 */

export const version = '0.1.11-beta.3';
